module.exports = __webpack_public_path__ + "img/商城广东联通语音.fdd1d5c8.png";